import { useState, useEffect } from "react";
import { IoClose } from "react-icons/io5";
import {
    BlockUser, GetBlockReasons
} from "../../services/api";
import { useNavigate } from "react-router-dom";

export default function ReportProfile({ userId, onClose }) {

    const navigate = useNavigate();

    const [reason, setReason] = useState("");
    const [reportData, setReportData] = useState([]);

    useEffect(() => {
        fetchBlockReasons();
    }, []);

    const fetchBlockReasons = () => {
        GetBlockReasons()
            .then((res) => {
                setReportData(res.data);
            })
            .catch((err) => {
                console.log(err)
            });
    }

    const OnSendClick = () => {

        const data = {
            blockedUserId: userId,
            reasonId: reason
        }

        BlockUser(data)
            .then((res) => {
                onClose();
                navigate("/explore");
            })
            .catch((err) => {
                console.log(err)
            });
    }

    return (
        <div className="fixed inset-0 bg-black/80 flex items-center justify-center z-50 px-4">
            <div className="bg-black border border-gray-700 rounded-2xl w-full max-w-md p-6 relative">

                {/* CLOSE */}
                <button
                    onClick={onClose}
                    className="absolute top-4 right-4 text-white text-2xl"
                >
                    <IoClose />
                </button>

                <h2 className="text-xl font-semibold mb-2 text-center">
                    Report and block
                </h2>

                <p className="text-sm text-gray-400 mb-6 text-center">
                    What's problem?
                </p>

                {/* OPTIONS */}
                {reportData.map((item) => (
                    <label
                        key={item._id}
                        className="flex items-center gap-3 mb-4 cursor-pointer"
                    >
                        <input
                            type="radio"
                            name="report"
                            value={item._id}
                            checked={reason === item._id}
                            onChange={(e) => setReason(e.target.value)}
                            className="accent-red-600"
                        />
                        <span>{item.title}</span>
                    </label>
                ))}

                {/* SEND BUTTON */}
                <button
                    disabled={!reason}
                    onClick={OnSendClick}
                    className="mt-4 w-full bg-red-700 hover:bg-red-800 disabled:opacity-50 py-3 rounded-full font-semibold"
                >
                    Send
                </button>

            </div>
        </div>
    );
}